import { AxiosInstance } from "axios";

export class DeepResearchService {
  client: AxiosInstance;
  serviceName = 'deep_research/deep-research-management';
  chatServiceName = 'deep_research/chat-message-management'
  streamingChatServiceName = 'deep_research/streaming-chat'
  researchStatus = 'deep_research/deep-research-status'
  exportResearch = 'deep_research/export-deep-research'
  constructor({ client }: { client: AxiosInstance }) {
    this.client = client;
  }

  startResearch({ seller_company_name, prospect_company_name, prospect_id, user_guide, research_level }: { seller_company_name: string, prospect_company_name: string, prospect_id: number, user_guide: string, research_level: string }) {
    return this.client.post(`${this.serviceName}/`, {
      seller_company_name,
      prospect_company_name,
      prospect_id,
      user_guide,
      research_level
    })
  }

  getResearch(params: any = {}) {
    const queryParams = new URLSearchParams(params);
    return this.client.get(`${this.serviceName}/?${queryParams.toString()}`);
  }

  getResearchStatus(params: any = {}) {
    const queryParams = new URLSearchParams(params);
    return this.client.get(`${this.researchStatus}/?${queryParams.toString()}`);
  }

  getChatMessages(campaign_id: number, user_id: number, receiver_id: number, page: number, pageSize: number) {
    return this.client.get(`${this.chatServiceName}/?campaign_id=${campaign_id}&user_id=${user_id}&receiver_id=${receiver_id}&page=${page}&page_size=${pageSize}`)
  }

  chat(query: string, user_id: number, receiver_id: number, campaign_id: number) {
    return fetch(`${this.client.defaults.baseURL}${this.streamingChatServiceName}/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(this.client.defaults.headers.common['Authorization'] && { 'Authorization': this.client.defaults.headers.common['Authorization'] as string }),
      },
      body: JSON.stringify({
        user_query: query,
        user_id,
        receiver_id,
        campaign_id,
      }),
    });
  }

  exportDocument(params: { id: string, type: string }) {
    return this.client.get(`${this.exportResearch}/?${new URLSearchParams(params).toString()}`, {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/pdf',
      }
    });
  }
}